import { defineComponent as _defineComponent } from 'vue'
import { computed, reactive, ref, toRef } from 'vue'
import { usePagination } from '@/components/jobs/pagination'
import { useJobsQuery } from '@/components/jobs/query'
import { useJobsSearch } from '@/components/jobs/search'
import FieldViewJobCard from './FieldViewJobCard.vue'
import VsWrapper from '@/components/vision/VsWrapper.vue'
import { useMapFilters } from '@/components/jobs/filters'
import JobSearchPagination from '@/components/jobs/job-search-page/JobSearchPagination.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'LocationDetailsJobTab',
  props: {
    locationId: null
  },
  setup(__props: any) {

const props = __props as {
  locationId: string | number | null
}



const locationIdRef = toRef(props, 'locationId')

const filters = useMapFilters()
const locationsFilter = computed(() =>
  locationIdRef.value ? [locationIdRef.value] : []
)
const { getCurrentPage, updatePage } = usePagination()
const jobsQuery = reactive(
  useJobsQuery(
    { ...filters, locations: locationsFilter },
    getCurrentPage,
    20,
    ref(['requested_start', 'number']), // sortBy
    ref([true, true]) // sortDesc
  )
)

const {
  jobs,
  hasNextPage,
  isFetching: isFetchingJobs,
  isFetched: isFetchedJobs,
  isRefetching: isRefetchingJobs,
} = useJobsSearch(jobsQuery)

const canShowJobs = computed(() => {
  if (isFetchingJobs.value && !isRefetchingJobs.value) {
    return false
  }
  return true
})

const noJobs = computed(() => {
  return isFetchedJobs.value && jobs.value.length === 0
})

return { __sfc: true,props, locationIdRef, filters, locationsFilter, getCurrentPage, updatePage, jobsQuery, jobs, hasNextPage, isFetchingJobs, isFetchedJobs, isRefetchingJobs, canShowJobs, noJobs, FieldViewJobCard, VsWrapper, JobSearchPagination }
}

})